import React from 'react'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { CompanyConsumer } from '../../../../CompanyContext'
import CompanyContentWrapper from '../CompanyContentWrapper'
import CompanyPaymentReceipts from './CompanyPaymentReceipts'
import { SEO } from '../../../Seo/seo'
import { payments } from '../../../../utils/pages-meta'
import { useIntl } from 'react-intl'
import InActiveCompanyContent from '../../../InActiveCompanyContent'


const PaymentReceiptsContent = ({ checkCompanyData, cid }) => {
  const intl = useIntl()
  return (
    <CompanyContentWrapper checkCompanyData={checkCompanyData} cid={cid}>
      <AuthenticatedUserConsumer>
        {({ selectedCompany }) => (
          <>
            {!!selectedCompany && !!Object.keys(selectedCompany).length &&
            <>
              <SEO
                title={intl.formatMessage({ id: 'PageTitle.PaymentReceipts' }) + ' - ' + selectedCompany.taxpayer_name}
                pathname={window.location.origin}
                titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
                image={payments.image}
                description={intl.formatMessage({ id: 'PageTitle.PaymentReceipts' }) + ' - ' + selectedCompany.taxpayer_name}
              />
              {!!selectedCompany.active && !!selectedCompany.company_user_active ?
                <CompanyConsumer>
                  {({ getPaymentReceipts, setBreadCrumbLinks, setBreadCrumbCurrent }) => (
                    <CompanyPaymentReceipts selectedCompany={selectedCompany}
                                            getPaymentReceipts={getPaymentReceipts}
                                            setBreadCrumbLinks={setBreadCrumbLinks}
                                            setBreadCrumbCurrent={setBreadCrumbCurrent}/>
                  )}
                </CompanyConsumer>
                : <InActiveCompanyContent/>
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </CompanyContentWrapper>
  )
}

export default PaymentReceiptsContent
